export default __webpack_public_path__ + "static/media/big-conor.7f5781bd.png";